// import { common } from '../common'

export const math = {
    // ...common,
    sum: (array,initValue=0) => array.reduce((pv, cv) => pv + cv,initValue)
}